// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";

function CryptoCurrencyNetworks(props) {
  var networkField = props.networkField;
  var networkPath = networkField.confirmRequestWritePath;
  var currencyFieldPath = props.currencyField.confirmRequestWritePath;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(networkField, localeString);
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(networkField, localeString);
  var currencyFieldProps = ReactFinalForm.useField(currencyFieldPath);
  var currencyVal = Core__Option.getOr(currencyFieldProps.input.value, "");
  var dropdownOptions = Core__Option.getOr(Utils$OrcaPaymentPage.currencyNetworksDict[currencyVal], []).map(function (item) {
        return {
                value: item,
                label: Utils$OrcaPaymentPage.toSpacedUpperCase(item, "_")
              };
      });
  var initialNetwork = Core__Option.getOr(Core__Option.map(dropdownOptions[0], (function (opt) {
              return opt.value;
            })), "");
  var field = ReactFinalForm.useField(networkPath, {
        initialValue: Caml_option.some(initialNetwork),
        validate: validate
      });
  React.useEffect((function () {
          if (initialNetwork !== "") {
            field.input.onChange(initialNetwork);
          }
          
        }), [initialNetwork]);
  var value = Core__Option.getOr(field.input.value, initialNetwork);
  return React.createElement(DropdownField$OrcaPaymentPage.make, {
              appearance: match.config.appearance,
              value: value,
              setValue: (function (setter) {
                  field.input.onChange(setter(value));
                }),
              fieldName: match$1.label,
              options: dropdownOptions,
              disabled: false
            });
}

var make = CryptoCurrencyNetworks;

export {
  make ,
}
/* jotai Not a pure module */
